var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 315,
    height: 193,
    viewBox: "0 0 315 193",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84 90V130M250 90V130",
    stroke: "#3D3D3D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M277 63L250 90V130L277 103V63Z",
    stroke: "#3D3D3D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M124.715 63H111L84 90H138.148M136.769 63H277L250 90H178.975M165.023 90H154.78",
    stroke: "#3D3D3D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M119.918 130H84L38 176H204L250 130H184.915",
    stroke: "#3D3D3D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M164 176L210 130",
    stroke: "#3D3D3D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M117.232 136.768L78 176",
    stroke: "#3D3D3D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M153.176 143.824L121 176",
    stroke: "#3D3D3D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62 153H226",
    stroke: "#3D3D3D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M97 77V40.2782V19C97 15.2288 97 13.3431 98.1716 12.1716C99.3431 11 101.229 11 105 11H128C131.771 11 133.657 11 134.828 12.1716C136 13.3431 136 15.2288 136 19V22.9098",
    stroke: "#3D3D3D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M231.5 70.5H137.526M106 79C108.599 76.4014 109.898 75.1021 111.355 74.0873C113.723 72.4384 116.42 71.3213 119.26 70.8129C120.716 70.5523 122.234 70.5087 124.824 70.5015",
    stroke: "#3D3D3D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M119 23H153",
    stroke: "#3D3D3D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M114 116L129.686 131.686C135.02 137.02 137.686 139.686 141 139.686C144.314 139.686 146.98 137.02 152.314 131.686L168 116",
    stroke: "#3D3D3D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M138 116L153.686 131.686C159.02 137.02 161.686 139.686 165 139.686C168.314 139.686 170.98 137.02 176.314 131.686L192 116",
    stroke: "#3D3D3D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M158 116H168V126",
    stroke: "#3D3D3D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M182 116H192V126",
    stroke: "#3D3D3D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M137.933 66.9682C137.933 71.1461 134.814 74.533 130.967 74.533C127.119 74.533 124 71.1461 124 66.9682C124 62.7903 130.967 54 130.967 54C130.967 54 137.933 62.7903 137.933 66.9682Z",
    stroke: "#3D3D3D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M178.933 87.9682C178.933 92.1461 175.814 95.533 171.967 95.533C168.119 95.533 165 92.1461 165 87.9682C165 83.7903 171.967 75 171.967 75C171.967 75 178.933 83.7903 178.933 87.9682Z",
    stroke: "#3D3D3D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M149.933 43.9682C149.933 48.1461 146.814 51.533 142.967 51.533C139.119 51.533 136 48.1461 136 43.9682C136 39.7903 142.967 31 142.967 31C142.967 31 149.933 39.7903 149.933 43.9682Z",
    stroke: "#3D3D3D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M158 99.4737C158 106.392 152.851 112 146.5 112C140.149 112 135 106.392 135 99.4737C135 92.5556 146.5 78 146.5 78C146.5 78 158 92.5556 158 99.4737Z",
    stroke: "#3D3D3D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.398231059e4cd0403804371bc5d2541c.svg";
export { ForwardRef as ReactComponent };